<template>
  <div>
    <WinnerContacts></WinnerContacts>
    <WinsCustomerInfo></WinsCustomerInfo>

    <!-- <h2 class="text-center colorblue">Реестр расчетов</h2> -->
    <template v-if="!orgSam">
      <v-card>
        <v-tabs v-model="tab" centered>
          <v-tab v-for="item in items" :key="item">{{ item }}</v-tab>
        </v-tabs>
      </v-card>
      <v-card>
        <v-tabs-items v-model="tab" class="mt-2">
          <v-tab-item>
            <v-card-text>
              <MyCalcTable />
            </v-card-text>
          </v-tab-item>
          <v-tab-item>
            <v-card-text>
              <AllUserCalcTable />
            </v-card-text>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </template>
    <template v-else>
      <MyCalcTable />
    </template>
  </div>
</template>

<script>
import WinnerContacts from "./calcRegister/WinsWinnerContacts";
import WinsCustomerInfo from "./calcRegister/WinsCustomerInfo";
import MyCalcTable from "./MyCalculationsTable";
import AllUserCalcTable from "./MyCalculationsTableAllUsers";
export default {
  components: {
    WinnerContacts,
    WinsCustomerInfo,
    MyCalcTable,
    AllUserCalcTable,
  },
  data: () => ({
    tab: 0,
    items: ["Мои расчеты", "Расчеты сотрудников"],
  }),
  computed: {
    orgSam() {
      const data = this.$store.getters.getMyOrganisation;
      const reg = /^Самозанятый/;
      return reg.test(data.orgShortName);
    },
  },
  mounted() {
    this.setTitle("Реестр расчетов");
  },
};
</script>

<style lang="scss">
</style>
